import PropTypes from 'prop-types';
import {Icon} from 'front-onceforall-core';
import {useSelector} from 'react-redux';
import NotificationDrawer from '../../../notification/NotificationDrawer';

function NotificationsView(props) {
  const notifications = useSelector(state => state.notifications);
  const {numberOfNewNotifications} = notifications.informationNotifications;

  return (
    <>
      <button
        type="button"
        ref={props.buttonRef}
        className="button-square"
        onClick={props.onNotificationDrawerButtonClick}
      >
        <Icon icon={notifications.isFetching ? 'loader' : 'notification'}/>
        {!notifications.isFetching && numberOfNewNotifications > 0 && !props.isDrawerOpen &&
          <span className={`badge small red${numberOfNewNotifications > 99 ? ' more-characters' : ''}`}>
            {numberOfNewNotifications > 99 ? '99+' : numberOfNewNotifications}
          </span>
        }
      </button>
      <div
        ref={props.drawerRef}
        style={{
          position: 'absolute',
          right: 0,
          top: '100%'
        }}
      >
        <NotificationDrawer
          show={props.isDrawerOpen}
          onNotificationClick={props.onNotificationClick}
          onHideDrawer={props.onNotificationDrawerButtonClick}
        />
      </div>
    </>
  );
}

NotificationsView.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  buttonRef: PropTypes.object.isRequired,
  drawerRef: PropTypes.object.isRequired,
  onNotificationDrawerButtonClick: PropTypes.func.isRequired,
  onNotificationClick: PropTypes.func.isRequired
};

export default NotificationsView;
